import React from 'react';
// eslint-disable-next-line import/extensions
import joinUsImg from '../../assets/images/careers/join_us.png';
import semiCircle from '../../assets/icons/semi-circle-white.svg';
import greyPolygon from '../../assets/icons/polygon-grey.svg';
import greyShape from '../../assets/icons/polygon-thick-border.svg';
import greenCircle from '../../assets/icons/circle-border-green.svg';
import { connect } from 'redux-zero/react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { PrimaryButton } from '../../components/ui-toolkit/buttons.js';
import { Helmet } from 'react-helmet';
import cn from 'classnames';

import { withLocaleContext } from '../../locales/locale-context.js';
import { actions } from '../../shared/store.js';
import CompaniesService from './companies.service.js';
import PageHeader from '../../components/page-header/page-header.component.js';
import NotImplemented from '../../components/not-implemented/not-implemented.js';

import './companies.scss';

const Company = ({
	className,
	id,
	title,
	logo,
	bg,
	label,
	description,
	link,
	handleCompany,
	activeCompany
}) => (
	<div
		className={`company ${cn({ active: id === activeCompany })} ${cn(
			className
		)} `}
		onClick={handleCompany}
	>
		{bg && bg.path && (
			<img
				className="bg"
				src={`${process.env.REACT_APP_API_ENDPOINT + bg.path}`}
				alt={id}
			/>
		)}
		<div className="company-info">
			<h5 className="title">{title}</h5>
			<p className="label">{label}</p>
			{logo.path ? (
				<img
					className="logo"
					src={`${process.env.REACT_APP_API_ENDPOINT + logo.path}`}
					alt={id}
				/>
			) : (
				<h5>{title}</h5>
			)}
			<p className="label-spotlight">{label}</p>
			<div className="content">
				<h6 className="description">{description}</h6>
				<p className="link">
					<a href={link} target="_blank" rel="noopener noreferrer">
						{link}
					</a>
				</p>
			</div>
		</div>
		<div className="view view-more" onClick={handleCompany}>
			<h6>
				<FormattedMessage id="button.view_more" />
			</h6>
		</div>
		<div className="view view-less" onClick={handleCompany}>
			<h6>
				<FormattedMessage id="button.view_less" />
			</h6>
		</div>
	</div>
);

class CompaniesPage extends React.Component {
	static prefetchData = async language =>
		Promise.all([
			CompaniesService.getCompaniesPageData(language),
			CompaniesService.getCompanies(language)
		]);

	state = {
		hasError: false,
		openCompany: -1,
		flipped: false
	};

	componentDidMount() {
		const { companiesPageData, companies, setLoading } = this.props;
		if (!companiesPageData || !companies) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const {
			localeContext: { locale }
		} = this.props;

		if (prevProps.localeContext.locale.value !== locale.value) {
			this.fetchData();
		}
	}

	handleCompany(id = null) {
		const { openCompany } = this.state;
		if (id === openCompany) {
			this.setState({
				openCompany: -1
			});
			return;
		}
		this.setState({
			openCompany: id
		});
	}

	flipCard() {
		const { flipped } = this.state;
		this.setState({
			flipped: !flipped
		});
	}

	fetchData() {
		const {
			setLoading,
			setCompaniesPageData,
			setCompanies,
			localeContext: { locale }
		} = this.props;

		setLoading(true);

		CompaniesPage.prefetchData(locale.value)
			.then(data => {
				setCompaniesPageData(data[0].data);
				setCompanies(data[1].data);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
				this.setState({
					hasError: true
				});
			});
	}

	render() {
		const { hasError, openCompany, flipped } = this.state;
		const { isLoading, companiesPageData, companies, intl } = this.props;

		if (isLoading) return null;

		if (hasError || !companiesPageData || !companies) {
			return <NotImplemented />;
		}

		const {
			title,
			subtitle,
			description,
			companyOnSpotlight,
			spotlightImage,
			joinUs
		} = companiesPageData;

		const numberOfColsDesktop = 3;
		let colNumberDesktop = 0;
		const colsDesktop = [];

		companies.forEach(company => {
			colsDesktop[colNumberDesktop] = colsDesktop[colNumberDesktop] || [];
			colsDesktop[colNumberDesktop].push(company);

			colNumberDesktop += 1;
			if (colNumberDesktop === numberOfColsDesktop) {
				colNumberDesktop = 0;
			}
		});

		return (
			<div id="companies-page">
				<Helmet>
					<title>
						{intl.formatMessage({
							id: 'navigation.companies'
						})}
					</title>
				</Helmet>
				<section className="header">
					<div className="container container-fluid">
						<div className="row">
							<div className="col-xs-12 col-md-12">
								<PageHeader
									title={intl.formatMessage({
										id: 'companies.button-title'
									})}
								/>
							</div>
							<div className="col-xs-12 col-md-6">
								<h2>{title}</h2>
							</div>
							<div className="col-xs-12 col-md-7 subtitle-col">
								<h6>{subtitle}</h6>
							</div>
							<div className="col-xs-12 col-md-6 description-col">
								<p>{description}</p>
							</div>
						</div>
					</div>
				</section>
				<section className="spotlight-col companies-cols">
					<div className="container container-fluid">
						<div className={`row spotlight  ${cn({ flipped })}`}>
							{companyOnSpotlight && (
								<div
									key="spotlightCompany"
									className="col-md-8 col-xs-12 col-sm-12 wrapper"
								>
									<Company
										className="front"
										key={companyOnSpotlight.title}
										id={companyOnSpotlight.title}
										label={companyOnSpotlight.label}
										title={intl.formatMessage({
											id: 'companies.spotlight'
										})}
										logo={companyOnSpotlight.image}
										bg={spotlightImage}
										description={companyOnSpotlight.description}
										link={companyOnSpotlight.link}
										handleCompany={() => this.flipCard()}
										activeCompany={companyOnSpotlight.title}
									/>
									<Company
										className="back"
										key={companyOnSpotlight.title}
										id={companyOnSpotlight.title}
										label={companyOnSpotlight.label}
										title={intl.formatMessage({
											id: 'companies.spotlight'
										})}
										logo={companyOnSpotlight.image}
										bg={spotlightImage}
										description={companyOnSpotlight.description}
										link={companyOnSpotlight.link}
										handleCompany={() => this.flipCard()}
										activeCompany={companyOnSpotlight.title}
									/>
								</div>
							)}
						</div>
					</div>
				</section>
				<section className="companies-cols">
					<div className="container container-fluid">
						<div className="row medium-organization">
							<div className="col-xs-12 col-sm-6 col-md-4 first-col">
								<div className="container">
									<div className="row">
										{colsDesktop[0] &&
											colsDesktop[0].map(company => (
												<div key={company.title} className="col-xs-12">
													<Company
														key={company.title}
														id={company.title}
														label={company.label}
														title={company.title}
														logo={company.image}
														description={company.description}
														link={company.link}
														handleCompany={() =>
															this.handleCompany(company.title)
														}
														activeCompany={openCompany}
													/>
												</div>
											))}
									</div>
								</div>
							</div>
							<div className="col-xs-12 col-sm-6 col-md-4 second-col">
								<div className="container">
									<div className="row">
										{colsDesktop[1] &&
											colsDesktop[1].map(company => (
												<div key={company.title} className="col-xs-12">
													<Company
														key={company.title}
														id={company.title}
														label={company.label}
														title={company.title}
														logo={company.image}
														description={company.description}
														link={company.link}
														handleCompany={() =>
															this.handleCompany(company.title)
														}
														activeCompany={openCompany}
													/>
												</div>
											))}
									</div>
								</div>
							</div>
							<div className="col-xs-12 col-sm-6 col-md-4 third-col">
								<div className="container">
									<div className="row">
										{colsDesktop[2] &&
											colsDesktop[2].map(company => (
												<div key={company.title} className="col-xs-12">
													<Company
														key={company.title}
														id={company.title}
														label={company.label}
														title={company.title}
														logo={company.image}
														description={company.description}
														link={company.link}
														handleCompany={() =>
															this.handleCompany(company.title)
														}
														activeCompany={openCompany}
													/>
												</div>
											))}
									</div>
								</div>
							</div>
						</div>
						<div className="row small-organization">
							<div className="col-xs-12 col-sm-12 small-col">
								<div className="container">
									<div className="row">
										{companies &&
											companies.map(company => (
												<div key={company.title} className="col-xs-12 col-sm-6">
													<Company
														key={company.title}
														id={company.title}
														label={company.label}
														title={company.title}
														logo={company.image}
														description={company.description}
														link={company.link}
														handleCompany={() =>
															this.handleCompany(company.title)
														}
														activeCompany={openCompany}
													/>
												</div>
											))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<section className="join-us">
					<img className="bg" src={joinUsImg} alt={joinUs.title} />
					<div className="container container-fluid content center-xs">
						<div className="row center-xs">
							<div className="col-xs-12 center-xs title">
								<h3>{joinUs.title} </h3>
							</div>
							<div className="col-xs-12 center-xs subtitle">
								<h6>{joinUs.subtitle}</h6>
							</div>
							<div className="col-xs-12 center-xs button">
								<PrimaryButton link={joinUs.link}>
									<FormattedMessage id={joinUs.btnLabel} />
								</PrimaryButton>
							</div>
						</div>
					</div>
					<span className="icons">
					<img className="semiCircle" src={semiCircle} alt="icon"/> 
					<img className="greyPolygon" src={greyPolygon} alt="icon"/>
					<img className="greyShape" src={greyShape} alt="icon"/>
					<img className="greenCircle" src={greenCircle} alt="icon"/>
				</span>
				</section>
			</div>
		);
	}
}

const mapToProps = ({ companiesPageData, companies }) => ({
	companiesPageData,
	companies
});

export default withLocaleContext(
	injectIntl(connect(mapToProps, actions)(CompaniesPage))
);

export { CompaniesPage };
